export const PAGE_HEIGHT = 'calc(100vh - 162px)';
